import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { ModalsModule } from '../../modals/modals.module';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { AccountCandidatesRouting } from './account-candidates.routing';
import { AccountCandidatesLayoutComponent } from './layout/account-candidates-layout.component';
import { AccountCandidatesSideMenuComponent } from './side-menu/account-candidates-side-menu.component';
import { AccountCandidatesListComponent } from './list/account-candidates-list.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { AccountCandidateComponent } from './candidate/account-candidate.component';
import { AccountCandidateAttributeComponent } from './attributes/account-candidate-attributes.component';
import { AccountCandidateTagsComponent } from './tags/account-candidate-tags.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TagElementComponent } from './tags/tag-element/tag-element.component';
import { CandidatesAdvancedFilterComponent } from './advanced-filter/candidate-advanced-filter.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@NgModule({
  declarations: [
    AccountCandidatesLayoutComponent,
    AccountCandidatesSideMenuComponent,
    AccountCandidatesListComponent,
    AccountCandidateAttributeComponent,
    AccountCandidateTagsComponent,
    AccountCandidateComponent,
    TagElementComponent,
    CandidatesAdvancedFilterComponent,
  ],
  exports: [
    AccountCandidatesLayoutComponent,
    AccountCandidatesSideMenuComponent,
    AccountCandidatesListComponent,
    AccountCandidateAttributeComponent,
    AccountCandidateTagsComponent,
    AccountCandidateComponent,
    CandidatesAdvancedFilterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ModalsModule,
    SharedModule,
    ReactiveFormsModule,
    AccountCandidatesRouting,
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
    TabsModule.forRoot(),
    ButtonsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    CollapseModule.forRoot(),
  ],
})
export class AccountCandidatesModule {
  constructor() {
    console.log('>>> Bootstrap AccountCandidatesModule');
  }
}
